import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  // SEATRC is hosted by the vionix-jotrseatrc Firebase project. Do not use the
  // apex jakartaopentrailrun.com domain here: it belongs to a different
  // Firebase project and causes Google Auth to reject the continue URI.
  authDomain: "seatrc.jakartaopentrailrun.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.appId) {
  throw new Error("Firebase configuration is incomplete");
}

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
if (!(db && typeof db === "object" && "app" in db)) {
  throw new Error("Firestore initialization failed");
}

const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

if (import.meta.env.VITE_FIREBASE_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  client_id: import.meta.env.VITE_FIREBASE_CLIENT_ID,
});

let analytics;
if (typeof window !== "undefined") {
  import("firebase/analytics").then(({ getAnalytics, isSupported }) => {
    isSupported().then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    });
  });
}

export { app, auth, db, storage, functions, analytics, googleProvider };
